import { usePageTracking } from '@/hooks/usePageTracking';
import { useScrollDepthTracking } from '@/hooks/useScrollDepthTracking';

/**
 * Component that tracks page views and scroll depth on SPA route changes
 * Must be placed inside BrowserRouter
 */
const PageTracker = () => {
  usePageTracking();
  useScrollDepthTracking();
  return null;
};

export default PageTracker;
